const Cards = () => {
  return (
<div class=" flex justify-center pb-4">
  <div class="text-center p-1 text-[#000000] z-10 font-raleway">
        <h1 className="font-bold text-base">Consultório Dra. Mayle Coelho</h1>
        <p class="text-base">CRO-SP: 168.426</p>
      <div>
        <p class="pt-2 text-base font-raleway max-w-68">Atendimento odontológico completo</p>
        <p class="pt-1 text-base font-raleway max-w-68">Clínica geral, estética e especialidades</p>
      </div>
  </div>
</div>
    
    
  );
};

export default Cards;
